import AccountDetailsUserInfo from './AccountDetailsUserInfo'
export default AccountDetailsUserInfo



// WEBPACK FOOTER //
// ./src/components/AccountDetailsUserInfo/index.js